import { render } from "./riskList.vue?vue&type=template&id=6feae47e&scoped=true"
import script from "./riskList.vue?vue&type=script&lang=js"
export * from "./riskList.vue?vue&type=script&lang=js"

import "./riskList.vue?vue&type=style&index=0&id=6feae47e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6feae47e"

export default script